export const WhatsAppConnectionState = {
  AUTHENTICATING: 'AUTHENTICATING',
  CONNECTED: 'CONNECTED',
  DEGRADED: 'DEGRADED',
  DISCONNECTED: 'DISCONNECTED',
  IDLE: 'IDLE',
  STARTING: 'STARTING',
  WAITING_QR: 'WAITING_QR'
}

const AUTHENTICATING_RAW_STATUSES = [
  'connecting',
  'inChat',
  'isLogged',
  'qrReadSuccess',
  'OPENING',
  'PAIRING'
]

const DISCONNECTED_RAW_STATUSES = [
  'autocloseCalled',
  'browserClose',
  'desconnectedMobile',
  'disconnectedMobile',
  'DISCONNECTED',
  'phoneNotConnected',
  'qrReadError',
  'qrReadFail',
  'serverClose',
  'UNLAUNCHED',
  'UNPAIRED'
]

export function normalizeConnectionStatus(status = {}) {
  if (
    status.isConnected === true &&
    (status.state === WhatsAppConnectionState.CONNECTED || status.rawState === 'CONNECTED')
  ) {
    return {
      state: WhatsAppConnectionState.CONNECTED,
      isConnected: true,
      requiresQr: false,
      message: 'Conectado ao WhatsApp'
    }
  }

  // requiresQr precisa prevalecer sobre o rawState notLogged deixado pelo
  // ciclo anterior; sem isso o frontend continua mostrando um QR expirado.
  if (status.requiresQr === true) {
    return {
      state: WhatsAppConnectionState.DISCONNECTED,
      isConnected: false,
      requiresQr: true,
      message:
        status.message ||
        'Gere um novo QR Code para conectar o WhatsApp'
    }
  }

  if (
    status.state === WhatsAppConnectionState.WAITING_QR &&
    Boolean(status.qrCode)
  ) {
    return {
      state: WhatsAppConnectionState.WAITING_QR,
      isConnected: false,
      requiresQr: false,
      message: 'Aguardando leitura do QR Code'
    }
  }

  if (
    status.state === WhatsAppConnectionState.AUTHENTICATING ||
    status.state === WhatsAppConnectionState.STARTING ||
    AUTHENTICATING_RAW_STATUSES.includes(status.rawState)
  ) {
    return {
      state: WhatsAppConnectionState.AUTHENTICATING,
      isConnected: false,
      requiresQr: false,
      message: 'Autenticando WhatsApp'
    }
  }

  if (status.state === WhatsAppConnectionState.DEGRADED) {
    return {
      state: WhatsAppConnectionState.DEGRADED,
      isConnected: false,
      requiresQr: false,
      message: 'Não foi possível confirmar a conexão'
    }
  }

  return {
    state: status.state || WhatsAppConnectionState.DISCONNECTED,
    isConnected: false,
    requiresQr: false,
    message: status.message || 'Desconectado do WhatsApp'
  }
}

export function normalizeSocketStatus(rawState) {
  if (rawState === 'CONNECTED') {
    return normalizeConnectionStatus({
      state: WhatsAppConnectionState.CONNECTED,
      rawState,
      isConnected: true
    })
  }

  if (rawState === 'notLogged') {
    return normalizeConnectionStatus({
      state: WhatsAppConnectionState.WAITING_QR,
      rawState
    })
  }

  if (AUTHENTICATING_RAW_STATUSES.includes(rawState)) {
    return normalizeConnectionStatus({
      state: WhatsAppConnectionState.AUTHENTICATING,
      rawState
    })
  }

  if (DISCONNECTED_RAW_STATUSES.includes(rawState)) {
    return normalizeConnectionStatus({
      state: WhatsAppConnectionState.DISCONNECTED,
      rawState
    })
  }

  return null
}
